export const ACTION_KEY_PARAM = 'action';

export const REPLY_TO_COMMENT_ACTION_TYPE = 'REPLY_TO_COMMENT';
